import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { DmsGridTemplateBase } from '../dms-grid-template-base';
import { IrisTagType } from '@iris/common/models/IrisTag';
import { ICellRendererParams } from 'ag-grid-community';
import { IrisDMSFolderOrFile } from '../../utils/file.utils';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IrisDMSTagI } from '@iris/common/modules/dms/models/IrisDMSTag';

@Component({
  selector: 'iris-dms-grid-tags-template',
  imports: [MatTooltipModule],
  templateUrl: './dms-grid-tags-template.component.html',
  styleUrls: ['./dms-grid-tags-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisDmsGridTagsTemplateComponent extends DmsGridTemplateBase {
  readonly tags = signal<IrisDMSTagI[]>([]);

  agInit(params: ICellRendererParams<IrisDMSFolderOrFile>): void {
    super.agInit(params);
    this.tags.set((params.data?.tags ?? []).filter(tag => tag.type === IrisTagType.DMS || !tag.type));
  }
}
